const AXES = [
  { key: "estetica", label: "Estetica" },
  { key: "armonia", label: "Armonia" },
  { key: "affinita", label: "Affinità" },
  { key: "equilibrio", label: "Equilibrio" },
];
const GOLD = "#C4A671";

export default function SensoryRadar({ sensory = {}, size = 200 }) {
  const c = size / 2;
  const R = c - 34;
  const xy = (i, r) => {
    const a = (Math.PI / 2) * i - Math.PI / 2;
    return [c + Math.cos(a) * r, c + Math.sin(a) * r];
  };
  const poly = (f) => AXES.map((_, i) => xy(i, R * f).join(",")).join(" ");
  const value = AXES.map((ax, i) => xy(i, R * ((sensory[ax.key] || 0) / 100)).join(",")).join(" ");

  return (
    <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} data-testid="sensory-radar">
      {[0.25, 0.5, 0.75, 1].map((f) => (
        <polygon key={f} points={poly(f)} fill="none" stroke="#2a2a2a" strokeWidth={0.7} />
      ))}
      {AXES.map((_, i) => {
        const [x, y] = xy(i, R);
        return <line key={i} x1={c} y1={c} x2={x} y2={y} stroke="#2a2a2a" strokeWidth={0.7} />;
      })}
      <polygon points={value} fill="rgba(196,166,113,0.22)" stroke={GOLD} strokeWidth={1.2} />
      {AXES.map((ax, i) => {
        const [x, y] = xy(i, R + 16);
        return (
          <g key={ax.key}>
            <text x={x} y={y - 3} textAnchor="middle" fill="#8B7A55" fontSize={7.5} letterSpacing={1.6} style={{ textTransform: "uppercase" }}>
              {ax.label}
            </text>
            <text x={x} y={y + 7} textAnchor="middle" fill={GOLD} fontSize={9.5} fontWeight={600}>
              {sensory[ax.key] ?? "—"}
            </text>
          </g>
        );
      })}
    </svg>
  );
}
